// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import DownOutlinedSvg from "@ant-design/icons-svg/lib/asn/DownOutlined";
import AntdIcon from "../components/AntdIcon";
const DownOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: DownOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    DownOutlined.displayName = "DownOutlined";
}
export default /*#__PURE__*/ React.forwardRef(DownOutlined);
